import { ResourceKey } from "i18next";

export const Interactions: ResourceKey = {
	close: "Close",
	open: "Open",
	copy: "Copy",
};
